import { marker } from '@colsen1991/ngx-translate-extract-marker';


export enum BsIconTypes {
    Printer = 'printer',
    FiletypeXlsx = 'filetype-xlsx',
    Pencil = 'pencil',
    Map = 'map',
    GripVertical = 'grip-vertical',
    Trash3 = 'trash3',
    Wallet2 = 'wallet2',
    Upload = 'upload',
    ExclamationTriangle = 'exclamation-triangle',
    Buildings = 'buildings',
    Diagram3 = 'diagram-3',
    Plus = 'plus',
    PlusLg = 'plus-lg',
    PlusCircle = 'plus-circle',
    Folder = 'folder',
    FolderPlus = 'folder-plus',
    Folder2 = 'folder2',
    Copy = 'copy',
    Funnel = 'funnel',
    Download = 'download',
    QuestionCircle = 'question-circle',
    FileEarmark = 'file-earmark',
    Eye = 'eye',
    EyeSlash = 'eye-slash',
    Geo = 'geo',
    Search = 'search',
    X = 'x',
    XLg = 'x-lg',
    ClockHistory = 'clock-history',
    Chat = 'chat',
    ChatFill = 'chat-fill',
    Person = 'person',
    DashCircle = 'dash-circle',
    Sticky = 'sticky',
    List = 'list',
    ListUl = 'list-ul',
    Cart = 'cart',
    ArrowCounterclockwise = 'arrow-counterclockwise',
    ArrowClockwise = 'arrow-clockwise',
    BoxArrowRight = 'box-arrow-right',
    Database = 'database',
    ArrowRight = 'arrow-right',
    ArrowLeft = 'arrow-left',
    Pass = 'pass',
    DeviceSsd = 'device-ssd',
    ArrowRepeat = 'arrow-repeat',
    Phone = 'phone',
    FileEarmarkText = 'file-earmark-text',
    InfoCircle = 'info-circle',
    QrCode = 'qr-code',
    Camera = 'camera',
    CheckLg = 'check-lg',
    PersonCheck = 'person-check',
    ChevronLeft = 'chevron-left',
}

export const bsIconTitleMap: Record<string, string> = {
    [BsIconTypes.Pencil]: marker('global.actions.edit'),
    [BsIconTypes.Printer]: marker('global.actions.print'),
    [BsIconTypes.FiletypeXlsx]: marker('global.actions.export'),
    [BsIconTypes.Trash3]: marker('global.actions.delete'),
    [BsIconTypes.Copy]: marker('global.actions.copy'),
    [BsIconTypes.Upload]: marker('global.actions.upload'),
    [BsIconTypes.Download]: marker('global.actions.download'),
    [BsIconTypes.Plus]: marker('global.actions.add'),
    [BsIconTypes.ClockHistory]: marker('global.labels.history'),
    [BsIconTypes.PlusCircle]: marker('global.actions.add'),
    [BsIconTypes.QuestionCircle]: marker('global.labels.info'),
    [BsIconTypes.Geo]: marker('ref.table-stops.show-on-map'),
    [BsIconTypes.Pass]: marker('global.labels.ticket'),
    [BsIconTypes.Cart]: marker('global.labels.basket'),
    [BsIconTypes.BoxArrowRight]: marker('global.actions.logout'),
    [BsIconTypes.ChevronLeft]: marker('ui.back-link.text'),
}
